function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M8.412 7.575l2.915-5.907a.75.75 0 011.346 0l2.915 5.907 6.52.953a.75.75 0 01.415 1.28l-4.717 4.594 1.113 6.491a.75.75 0 01-1.088.79L12 18.618l-5.83 3.067a.75.75 0 01-1.09-.79l1.114-6.492-4.717-4.595a.75.75 0 01.415-1.28l6.52-.952zM12 3.695L9.583 8.591a.75.75 0 01-.565.41l-5.407.79 3.912 3.81a.75.75 0 01.216.665l-.923 5.382 4.835-2.543a.75.75 0 01.698 0l4.835 2.543-.923-5.382a.75.75 0 01.216-.664l3.912-3.81-5.407-.79a.75.75 0 01-.565-.411L12 3.694z"
  }));
};
SvgStar.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgStar.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgStar;